export function getScrollingElement(childEl?: Element): HTMLElement | null {
	if (childEl) {
		return childEl.closest(".app-main");
	}
	return document.querySelector(".app-main");
}
